import React from "react";
import "./SofaSpringRepair.css";
import {
  FaTools,
  FaCheckCircle,
  FaArrowRight,
  FaWhatsapp,
  FaPhone,
  FaCouch,
  FaShieldAlt,
  FaWrench,
} from "react-icons/fa";

import Footer from "../footer/Footer";
import Location from "../location/Location";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";

export default function SofaSpringRepair() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const openWhatsApp = (message) => {
    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const services = [
    {
      icon: <FaTools />,
      title: "Broken Spring Repair",
      text: "Damaged and broken sofa springs are repaired or replaced to restore proper seating support.",
    },
    {
      icon: <FaCouch />,
      title: "Sagging Sofa Repair",
      text: "We repair sagging sofa seats caused by weak, loose or damaged spring systems.",
    },
    {
      icon: <FaWrench />,
      title: "Spring Replacement",
      text: "Worn-out springs are replaced with suitable quality springs according to your sofa.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Spring Support Repair",
      text: "Loose spring support and internal sofa structure are checked and strengthened.",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Inspection",
      text: "We inspect the sofa seat, spring system, frame and internal support.",
    },
    {
      number: "02",
      title: "Problem Check",
      text: "Our technician identifies broken, loose or damaged spring components.",
    },
    {
      number: "03",
      title: "Repair",
      text: "Damaged springs are repaired or replaced using suitable materials.",
    },
    {
      number: "04",
      title: "Final Check",
      text: "The sofa is checked for proper support, comfort and stability.",
    },
  ];

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="rk-spring-hero">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div className="rk-spring-content">

                <div className="rk-spring-eyebrow">
                  <span></span>
                  PROFESSIONAL SOFA SPRING REPAIR
                </div>

                <h1>
                  Fix Your Sofa's
                  <br />
                  <em>Spring & Support.</em>
                </h1>

                <p className="rk-spring-intro">
                  Professional sofa spring repair service in Noida for broken,
                  loose and sagging sofa springs. We restore your sofa's
                  support and seating comfort with practical repair solutions.
                </p>

                <div className="rk-spring-actions">

                  <a
                    href={`tel:${PHONE}`}
                    className="rk-spring-call"
                  >
                    <FaPhone />

                    <span>
                      <small>CALL OUR EXPERT</small>
                      Call Now
                    </span>
                  </a>

                  <button
                    type="button"
                    className="rk-spring-whatsapp"
                    onClick={() =>
                      openWhatsApp(
                        "Hi RK Sofa Works, I need sofa spring repair service in Noida."
                      )
                    }
                  >
                    <FaWhatsapp />
                    WhatsApp Us
                    <FaArrowRight />
                  </button>

                </div>

                <div className="rk-spring-trust">

                  <div>
                    <FaCheckCircle />
                    <span>Experienced Craftsmen</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Quality Springs</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Doorstep Inspection</span>
                  </div>

                </div>

              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6">

              <div className="rk-spring-image-box">

                <div className="rk-spring-image-frame">

                  <img
                    src="/img/sofa_spring.png"
                    alt="Sofa Spring Repair Service in Noida"
                  />

                  <div className="rk-spring-image-gradient"></div>

                </div>

                <div className="rk-spring-service-card">

                  <div className="rk-spring-service-icon">
                    <FaWrench />
                  </div>

                  <div>
                    <strong>Spring Repair</strong>
                    <span>Restore Sofa Support</span>
                  </div>

                </div>

              </div>

            </div>

          </div>
        </div>
      </section>

      {/* ================= STATS ================= */}
      <section className="rk-spring-stats">
        <div className="container">

          <div className="rk-spring-stats-inner">

            <div className="rk-spring-stat">
              <strong>18+</strong>
              <span>Years Experience</span>
            </div>

            <div className="rk-spring-divider"></div>

            <div className="rk-spring-stat">
              <strong>2500+</strong>
              <span>Sofas Serviced</span>
            </div>

            <div className="rk-spring-divider"></div>

            <div className="rk-spring-stat">
              <strong>100%</strong>
              <span>Quality Focus</span>
            </div>

            <div className="rk-spring-divider"></div>

            <div className="rk-spring-stat">
              <strong>Noida</strong>
              <span>Doorstep Service</span>
            </div>

          </div>

        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="rk-spring-services">

        <div className="container">

          <div className="rk-spring-heading">

            <span>WHAT WE REPAIR</span>

            <h2>
              Complete Sofa Spring
              <br />
              <em>Repair Solutions</em>
            </h2>

            <p>
              From broken springs to sagging seats, we identify the actual
              problem and provide the right repair solution.
            </p>

          </div>

          <div className="row g-4">

            {services.map((item, index) => (
              <div
                className="col-sm-6 col-lg-3"
                key={index}
              >
                <article className="rk-spring-service-card-box">

                  <div className="rk-spring-card-top">

                    <span>
                      0{index + 1}
                    </span>

                    <div className="rk-spring-card-icon">
                      {item.icon}
                    </div>

                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                  <div className="rk-spring-card-line"></div>

                  <button
                    type="button"
                    onClick={() =>
                      openWhatsApp(
                        `Hi RK Sofa Works, I need ${item.title.toLowerCase()} service for my sofa.`
                      )
                    }
                  >
                    Enquire Now
                    <FaArrowRight />
                  </button>

                </article>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="rk-spring-quality">

        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-5">

              <div className="rk-spring-quality-image">

                <img
                  src="/img/sofa_spring_1.png"
                  alt="Sofa spring repair work"
                />

                <div className="rk-spring-quality-label">
                  <FaShieldAlt />

                  <span>
                    Strong Support
                    <br />
                    Comfortable Seating
                  </span>
                </div>

              </div>

            </div>

            <div className="col-lg-7">

              <div className="rk-spring-quality-content">

                <span className="rk-spring-small-heading">
                  WHY CHOOSE RK SOFA WORKS
                </span>

                <h2>
                  Bring Back Your Sofa's
                  <br />
                  <em>Original Support.</em>
                </h2>

                <p>
                  A damaged spring system can make your sofa uncomfortable and
                  cause the seat to sag. Our sofa spring repair service focuses
                  on restoring proper support instead of simply covering the
                  problem.
                </p>

                <div className="rk-spring-quality-list">

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Proper Inspection</strong>
                      <span>
                        We check the internal spring and frame condition.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Suitable Materials</strong>
                      <span>
                        Springs and support materials are selected according
                        to the sofa.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Comfort Restoration</strong>
                      <span>
                        We focus on improving seat support and comfort.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Professional Work</strong>
                      <span>
                        Repair work is handled by experienced sofa craftsmen.
                      </span>
                    </div>
                  </div>

                </div>

                <button
                  type="button"
                  className="rk-spring-quality-btn"
                  onClick={() =>
                    openWhatsApp(
                      "Hi RK Sofa Works, I want to get my sofa spring system inspected."
                    )
                  }
                >
                  Get Sofa Inspection
                  <FaArrowRight />
                </button>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="rk-spring-process">

        <div className="container">

          <div className="rk-spring-heading">

            <span>HOW IT WORKS</span>

            <h2>
              Our Sofa Spring Repair
              <br />
              <em>Process</em>
            </h2>

            <p>
              A simple process from inspection to final comfort check.
            </p>

          </div>

          <div className="rk-spring-process-grid">

            {process.map((item, index) => (
              <div
                className="rk-spring-process-item"
                key={item.number}
              >

                <div className="rk-spring-process-number">
                  {item.number}
                </div>

                <div className="rk-spring-process-content">

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                </div>

                {index !== process.length - 1 && (
                  <div className="rk-spring-process-arrow">
                    <FaArrowRight />
                  </div>
                )}

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="rk-spring-cta">

        <div className="container">

          <div className="rk-spring-cta-inner">

            <div>

              <span>
                SOFA FEELS SAGGY OR UNCOMFORTABLE?
              </span>

              <h2>
                Let Us Check Your
                <br />
                Sofa Springs.
              </h2>

              <p>
                Send us a few photos of your sofa and our team can guide you
                about the possible spring repair.
              </p>

            </div>

            <button
              type="button"
              onClick={() =>
                openWhatsApp(
                  "Hi RK Sofa Works, my sofa has a spring problem. I am sharing photos for inspection."
                )
              }
            >
              <FaWhatsapp />
              Send Sofa Photos
              <FaArrowRight />
            </button>

          </div>

        </div>
      </section>

      <Offer />
      <Location />
      <Footer />
    </>
  );
}
